import isString from 'lodash/isString';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { Schema } from '@/widgets/FormBuilder/types';
import { SearchFormTemplate } from '@/widgets/Templates';

import CriminalRecordSearchSchema from '@/shared/data/schemas/services/CEAA02.json';

import { useMutation } from '@tanstack/react-query';

import { ServiceNames } from '@/config/services';

import api from '../../../../../api/api';

export const CheckForm: React.FC = () => {
  const { state } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(state?.search);

  const [qrParams] = useState<{
    data: string | null;
    path: string | null;
    requestId: string | null;
    verifyCode: string | null;
  }>({
    data: searchParams.get('data'),
    path: searchParams.get('path'),
    requestId: searchParams.get('requestId'),
    verifyCode: searchParams.get('verify_code'),
  });

  const [initialValues] = useState({
    numb: searchParams.get('numb') || '',
    birthDate: searchParams.get('birth_date') || undefined,
  });

  const {
    mutate: loadSearch,
    data: searchData,
    isPending: isLoading,
    isSuccess: hasBeenFetched,
  } = useMutation({
    mutationFn: (params: Parameters<typeof api.iac.search>[0]) => api.iac.search(params),
  });
  const result = searchData;

  const isQR: boolean = useMemo(
    () => (searchParams.has('data') && searchParams.has('path')) || searchParams.has('requestId'),
    [searchParams],
  );

  useEffect(() => {
    if (!isQR) {
      return;
    }

    const filteredParams = Object.fromEntries(Object.entries(qrParams).filter(([_, value]) => value !== null));

    loadSearch({
      type: 'qr',
      ...filteredParams,
    });
  }, [isQR, qrParams, loadSearch]);

  return (
    <SearchFormTemplate
      serviceName={ServiceNames.CEAA02}
      formTitle="Вкажіть дані пошуку"
      formSchema={CriminalRecordSearchSchema as unknown as Schema}
      initialValues={initialValues}
      formSubmit={(data) => {
        setSearchParams([
          ['numb', data.numb],
          ['birth_date', data.birthDate ?? ''],
        ]);
        loadSearch({ ...data, type: 'simple' });
      }}
      result={result}
      isLoading={isLoading}
      hasBeenFetched={hasBeenFetched}
      resultType={{
        type: 'grid',
        gridProps: {
          data: isString(result) ? [] : (result as Exclude<typeof result, string>)?.data?.data || [],
          title: 'Витяг',
          placeholder: 'Не вказано',
          isHtmlData: true,
        },
      }}
    />
  );
};
